import ApiService from './api.service'

const TaskService = {
    get() {

    },

    getTasks(nodeTypeTypePublicCode, energyTypePublicCode, periodFrom, periodTo, idUserWorker, idCompany, addressSearchString, personalAccount, meterSerialNumber, taskTypePublicCode, status, sortColumns, page, count) {
      return ApiService.get('/api/tasks', {
        params: {
          NodeTypeTypePublicCode: nodeTypeTypePublicCode,
          EnergyTypePublicCode: energyTypePublicCode,
          PeriodFrom: periodFrom,
          PeriodTo: periodTo,
          IdUserWorker: idUserWorker,
          IdCompany: idCompany,
          AddressSearchString: addressSearchString,
          PersonalAccount: personalAccount,
          MeterSerialNumber: meterSerialNumber,
          TaskTypePublicCode: taskTypePublicCode,
          Status: status,
          SortColumns: sortColumns,
          Page: page,
          Count: count
        }
      })
    },

    getActs(nodeTypeTypePublicCode, energyTypePublicCode, statusAlmatySu, statusAlseco, statusAsdsp, serialNumber, periodFrom, periodTo, idUserWorker, idCompany, addressSearchString, personalAccount, meterSerialNumber, taskTypePublicCode, page, count) {
      console.log(nodeTypeTypePublicCode, energyTypePublicCode)
      return ApiService.get('/api/tasks/acts', {
        params: {
          NodeTypeTypePublicCode: nodeTypeTypePublicCode,
          EnergyTypePublicCode: energyTypePublicCode,
          StatusAlmatySu: statusAlmatySu,
          StatusAlseco: statusAlseco,
          StatusAsdsp: statusAsdsp,
          SerialNumber: serialNumber,
          PeriodFrom: periodFrom,
          PeriodTo: periodTo,
          IdUserWorker: idUserWorker,
          IdCompany: idCompany,
          AddressSearchString: addressSearchString,
          PersonalAccount: personalAccount,
          MeterSerialNumber: meterSerialNumber,
          TaskTypePublicCode: taskTypePublicCode,
          Page: page,
          Count: count
        }
      })
    },

    getLastVerificationProtocols() {
      return ApiService.get('/api/tasks/last-verification-protocols')
    },

    getVerificationProtocols(periodFrom, periodTo, addressSearchString, personalAccount, energyTypePublicCode, 
      meterSerialNumber, serialNumber,  idCompany, page, count) {

      return ApiService.get('/api/tasks/verification-protocols', {
        params: {
          PeriodFrom: periodFrom,
          PeriodTo: periodTo,
          AddressSearchString: addressSearchString,
          PersonalAccount: personalAccount,
          EnergyTypePublicCode: energyTypePublicCode,
          MeterSerialNumber: meterSerialNumber,
          SerialNumber: serialNumber,
          IdCompany: idCompany,          
          Page: page,
          Count: count
        }
      })
    },

    getActsByReestr(idReestrCold, idReestrHot, taskTypePublicCode) {
      return ApiService.get('/api/tasks/acts-reestr', {
        params: {
          IdReestrCold: idReestrCold,
          IdReestrHot: idReestrHot,
          TaskTypePublicCode: taskTypePublicCode
        }
      })
    },

    getActReestrs(idCompany, serialNumber, status, energyTypePublicCode, page, count) {
      return ApiService.get('/api/tasks/acts/reestr', {
        params: {
          IdCompany: idCompany,
          SerialNumber: serialNumber,
          Status: status,
          EnergyTypePublicCode: energyTypePublicCode,
          Page: page,
          Count: count
        }
      })
    },

    getActLogs(idAct, page, count) {
      return ApiService.get('/api/tasks/acts/logs', {
        params: {
          IdAct: idAct,          
          Page: page,
          Count: count
        }
      })
    },

    getTask(id) {
      return ApiService.get('/api/tasks/'+id)
    },

    getAct(idTask) {
      return ApiService.get('/api/tasks/acts/'+idTask)
    },

    getActReestr(id) {
      return ApiService.get('/api/tasks/acts/reestr/'+id)
    },

    getWorks(id) {
      return ApiService.get('/api/tasks/works/'+id) 
    },

    getTypes(id) {
      return ApiService.get('/api/tasks/task-types', {
        params: {
          Id: id
        }
      })
    },

    getApkNodes(providers, typePublicCode, searchString, page, count) {
      return ApiService.get('/api/tasks/apk-nodes', {
        params: {
          Providers: providers,
          TypePublicCode: typePublicCode,
          SearchString: searchString,
          Page: page,
          Count: count
        }
      })
    },

    getApkNode(providers, typePublicCode, personalAccount, address, idClient) {
      return ApiService.get('/api/tasks/apk-node', {
        params: {
          Providers: providers,
          TypePublicCode: typePublicCode,
          PersonalAccount: personalAccount,
          Address: address,
          IdClient: idClient,
        }
      })      
    },

    getApkMeterTypes(provider, nodeTypePublicCode, energyMeterTypePublicCode, sortColumn) {
      return ApiService.get('/api/tasks/apk-meter-types', {
        params: {
          Provider: provider,
          NodeTypePublicCode: nodeTypePublicCode,
          EnergyMeterTypePublicCode: energyMeterTypePublicCode,
          SortColumn: sortColumn
        }
      })
    },
   
    getInstallPlaces(id) {
      return ApiService.get('/api/tasks/apk-install-places', {
        params: {
          Id: id
        }
      })
    },

    createTask(nodeTypePublicCode, idUserWorker, contactPerson, contactPhone, creatorComment, apkNodeJson, workDate, worksJson) {
      let task = {        
        nodeTypePublicCode: nodeTypePublicCode,
        idUserWorker: idUserWorker,
        contactPerson: contactPerson,
        contactPhone: contactPhone,
        creatorComment: creatorComment,        
        apkNodeJson: apkNodeJson,        
        workDate: workDate,
        worksJson: worksJson,
      }
      return ApiService.post(`/api/tasks`, task)
    },

    createAct(idTask, creationType, idColdWaterActNumber, coldWaterActDate, idHeatInActNumber, heatInActDate, idHeatOutActNumber, heatOutActDate, idUserWorker, contactPerson, contactPhone, creatorComment, workerComment, worksJson) {
      let act = {        
        idTask: idTask,
        creationType: creationType,
        idColdWaterActNumber: idColdWaterActNumber,
        coldWaterActDate: coldWaterActDate,
        idHeatInActNumber: idHeatInActNumber,
        heatInActDate: heatInActDate,
        idHeatOutActNumber: idHeatOutActNumber,
        heatOutActDate: heatOutActDate,
        idUserWorker: idUserWorker,
        contactPerson: contactPerson,
        contactPhone: contactPhone,
        creatorComment: creatorComment,        
        workerComment: workerComment,        
        worksJson: worksJson,
      }
      return ApiService.post(`/api/tasks/act`, act)
    },

    createVerificationProtocol(idUserWork, serialNumber, protocolParams) {
      let act = {        
        idUserWork: idUserWork,
        serialNumber: serialNumber,
        protocolParams: protocolParams
      }
      return ApiService.post(`/api/tasks/verification-protocol`, act)
    },

    createActReestr(energyTypePublicCode, periodTo) {
      let act = {        
        energyTypePublicCode: energyTypePublicCode,
        periodTo: periodTo,
      }
      return ApiService.post(`/api/tasks/acts/reestr`, act)
    },

    updateTask(idUserTask, idUserWorker, contactPerson, contactPhone, creatorComment, workDate, worksJson) {
      let task = {  
        idUserTask: idUserTask,        
        idUserWorker: idUserWorker,
        contactPerson: contactPerson,
        contactPhone: contactPhone,
        creatorComment: creatorComment,    
        workDate: workDate,
        worksJson: worksJson,
      }
      return ApiService.put(`/api/tasks`, task)
    },

    updateTaskPrice(id, cost){
      let taskPrice = {
        id: id,
        cost: cost
      }
      return ApiService.put(`/api/tasks/task-types-cost`, taskPrice)
    },

    updateAct(idTask, idColdWaterActNumber, coldWaterActDate, idHeatInActNumber, heatInActDate, idHeatOutActNumber, heatOutActDate, idUserWorker, contactPerson, contactPhone, creatorComment, workerComment, worksJson) {
      let act = {        
        idTask: idTask,
        idColdWaterActNumber: idColdWaterActNumber,
        coldWaterActDate: coldWaterActDate,
        idHeatInActNumber: idHeatInActNumber,
        heatInActDate: heatInActDate,
        idHeatOutActNumber: idHeatOutActNumber,
        heatOutActDate: heatOutActDate,
        idUserWorker: idUserWorker,
        contactPerson: contactPerson,
        contactPhone: contactPhone,
        creatorComment: creatorComment,        
        workerComment: workerComment,        
        worksJson: worksJson,
      }
      return ApiService.put(`/api/tasks/act`, act)
    },

    updateVerificationProtocol(idUserWork, serialNumber, protocolParams) {
      let act = {        
        idUserWork: idUserWork,
        serialNumber: serialNumber,
        protocolParams: protocolParams
      }
      return ApiService.put(`/api/tasks/verification-protocol`, act)
    },

    unlinkActsAndPlombs(idAct, provider, unlinkPlombs, unlinkActs) {
      let act = {        
        idAct: idAct,
        provider: provider,
        unlinkPlombs: unlinkPlombs,
        unlinkActs: unlinkActs,
       }
      return ApiService.put(`/api/tasks/act/plombs`, act)
    },

    updateActReestr(id, status) {
      let act = {        
        id: id,
        status: status,
      }
      return ApiService.put(`/api/tasks/acts/reestr`, act)
    },

    cancelTask(id, workerComment) {
      let task = {  
        id: id,        
        workerComment: workerComment,        
      }
      return ApiService.put(`/api/tasks/cancel`, task)
    },

    deleteTask(id) {
      return ApiService.delete(`/api/tasks/${id}`)
    },

    deleteAct(id) {
      return ApiService.delete(`/api/tasks/acts/${id}`)
    },

    deleteVerificationProtocol(id) {
      return ApiService.delete(`/api/tasks/verification-protocol/${id}`)
    },

    deleteActReestr(id) {
      return ApiService.delete(`/api/tasks/acts/reestr/${id}`)
    },

    sendActToAlmatySu(idAct, energy) {
      let act = {        
        idAct: idAct,
        energy: energy,
      }
      return ApiService.post(`/api/tasks/acts/send-almaty-su`, act)
    },

    sendRequestActStatusToAlmatySu(idAct, energy, idActAiscra) {
      let act = {        
        idAct: idAct,
        energy: energy,
        idActAiscra: idActAiscra,
      }
      return ApiService.post(`/api/tasks/acts/send-request-status-almaty-su`, act)
    },

    sendActToAlseco(idAct) {
      let act = {        
        idAct: idAct,
      }
      return ApiService.post(`/api/tasks/acts/send-alseco`, act)
    },

    sendActToAsdsp(idAct) {
      let act = {        
        idAct: idAct,
      }
      return ApiService.post(`/api/tasks/acts/send-asdsp`, act)
    },

    createActLog(idAct, status, message) {
      let log = {        
        idAct: idAct,
        status: status,
        message: message,
      }
      return ApiService.post(`/api/tasks/logs`, log)
    },
}

export default TaskService